<div class="m-0 p-0 row h-100 w-100 vw-100" [class.nybolig-theme]="enable365">
  <div
    class="marginOnBigScreen col-11 col-md-11 col-lg-4 col-xl-4 mx-auto text-center mb-100px"
    style="z-index: 999 !important"
  >
    <div class="mx-auto" style="max-width: 460px">
      <img
        *ngIf="!enable365"
        class="imga2 mb-4 mt-5 mt-lg-0"
        width="200"
        [alt]="env.name"
        src="/assets/img/a2-orange.svg"
      />
      <img
        style="margin-bottom: 10px; margin-top: 80px"
        *ngIf="enable365"
        width="200"
        [alt]="env.name"
        src="/assets/img/nybolig-black.svg"
      />
      <h3 class="mb-4" i18n="Welcome Agian Label">
        {{ "welcomeAgain" | transloco }}
      </h3>
      <ng-container *ngIf="!enable365">
        <p class="text-muted mb-4" i18n="Sign in label">
          {{ "signInNowByEntering" | transloco }}<br />{{
            "yourEmailAndPassword" | transloco
          }}
        </p>
        <form
          class="d-grid gap-2 mb-4 text-start"
          [formGroup]="loginForm"
          (ngSubmit)="submit()"
        >
          <div
            class="form-group mb-3"
            [class.is-invalid]="
              loginForm.get('email')?.errors && loginForm.get('email')?.touched
            "
          >
            <label
              for="email"
              class="form-label fw-bold d-block text-start w-100"
              style="color: #344054; font-size: 14px; font-weight: 500"
            >
              Email
            </label>
            <input
              formControlName="email"
              type="text"
              class="border8 inpt"
              id="email"
              placeholder="{{ 'Enter your email' }}"
              i18n-placeholder="Email placeholder @@email"
            />
          </div>
          <label
            for="password"
            class="form-label fw-bold d-block text-start w-100"
            style="color: #344054; font-size: 14px; font-weight: 500"
          >
            Password
          </label>
          <div
            class="form-group form-floating"
            [class.is-invalid]="
              loginForm.get('password')?.errors &&
              loginForm.get('password')?.touched
            "
          >
            <input
              formControlName="password"
              type="password"
              class="border8 inpt"
              id="password"
              placeholder="{{ '••••••••' }}"
              i18n-placeholder="Password placeholder @@password"
            />

            <button
              type="button"
              class="btn btn-link text-danger tooltip-btn"
              data-bs-toggle="tooltip"
              data-bs-placement="left"
              id="passworderror"
              [hidden]="!title"
              [title]="title"
            >
              <i class="bi bi-info-circle"></i>
            </button>
          </div>
          <div
            class="form-check float-start d-flex align-items-center justify-content-between"
          >
            <div class="border8">
              <input
                class="form-check-input"
                formControlName="rememberMe"
                id="rememberMe"
                type="checkbox"
              />
              <label
                style="color: #344054"
                class="float-start"
                for="rememberMe"
                i18n="Remember user label"
                >{{ "rememberMe" | transloco }}</label
              >
            </div>
            <div>
              <p class="mb-0">
                <a
                  routerLink="/forgotpassword"
                  class="btn btn-link"
                  style="
                    font-family: &quot;Inter&quot;, sans-serif;
                    font-weight: 600;
                    font-size: 16px;
                    line-height: 24px;
                  "
                  i18n="Button forgot password"
                  >{{ "forgotYourPassword" | transloco }}</a
                >
              </p>
            </div>
          </div>
          <button
            type="submit"
            [disabled]="repo.isLoading$ | async"
            class="btn btn-orange border8 btntxt btn-default btn-block mt-3"
            style="background-color: #ff4405 !important; z-index: 3"
          >
            <ng-container
              class="textBold"
              *ngIf="!(repo.isLoading$ | async)"
              i18n="Button sign in"
              >{{ "signIn" | transloco }}</ng-container
            >
            <app-spinner *ngIf="repo.isLoading$ | async"></app-spinner>
          </button>
        </form>
      </ng-container>
      <button
        *ngIf="enable365"
        [class.nybolig-theme]="enable365"
        type="button"
        class="btn bg-white border8 btntxt btn-block mt-2 w-100 d-flex justify-content-center align-items-center gap-2"
        style="
          color: #344054;
          border: 1px solid #d0d5dd;
          box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
          padding: 12px;
        "
        (click)="loadSettings()"
      >
        <img
          src="/assets/img/Office365Logo.png"
          width="20"
          height="24"
          onerror="this.style.display = 'none'"
        />
        {{ "loginUsingOffice365" | transloco }}
      </button>
    </div>
    <app-error-alert
      *ngIf="error"
      title="{{ 'alreadyLoginedByAnotherMicrosoftAccount' | transloco }}"
      i18n-title="Already logined by another microsoft account"
      errors="error"
    >
    </app-error-alert>
  </div>
  <div
    [class]="
      'col-12 col-md-12 col-lg-12 col-xl-6 showOnBigScreen d-flex align-items-center justify-content-center flex-column ' +
      (enable365 ? 'sideBackgroundNybolig' : 'sideBackground')
    "
  >
    <div class="allanGroup">
      <img class="imageAllanSign" src="/assets/img/AllanSign.png" />
      <img class="imageAllan" src="/assets/img/AllanImage.png" />
      <span class="titleAllan">
        Allan Kirkeby Andreasen <br />
        <span class="textBold">Projektleder & chef</span>
      </span>
    </div>
  </div>
</div>
